<template>
  <div class="list-item" @click="itemClick">
    <div class="order-header">
      <div class="flex-row">
        <img
          src="../assets/sinopec_logo.png"
          alt=""
          class="img"
          v-if="~~item.cardProductType === 1"
        />
        <img src="../assets/petrol_china_logo.png" alt="" class="img" v-else/>
        <span class="orderNo">{{ item.productName }}</span>
      </div>
      <div
        class="orderStatus"
        :class="{ blue: item.rechargeStatus == CarLifeOrderStatus.unpaid }"
      >
        {{ item.rechargeStatusName }}
      </div>
    </div>
    <div class="content">
      <div class="content-flex">
        <div class="left">订单编号</div>
        {{ item.orderNo }}
      </div>
      <div class="content-flex">
        <span class="left">下单时间</span>
        {{ item.createTime }}
      </div>
      <div class="content-flex">
        <span class="left">支付金额</span>
        ¥ {{ item.paidPrice || 0 }}元
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/common/util.js";
import { CarLifeOrderStatus } from "@/common/constant";

export default {
  name: "record-item",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      CarLifeOrderStatus,
    }
  },
  methods: {
    itemClick() {
      this.$router.push({
        path: '/refuelDetail',
        query: {
          orderNo: this.item.orderNo
        }
      })
    },
    dateTransform(dateTimestamp) {
      if (dateTimestamp) {
        return Utils.formatTimestamp(dateTimestamp);
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  background: white;
  margin-top: 12px;

  .order-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 1.2rem;
    box-shadow: inset 0px -1px 0px 0px rgba(230, 230, 230, 1);
    padding: 0 .4rem;

    .flex-row {
      word-break: break-all;
      height: 1.2rem;
      display: flex;
      flex-direction: row;
      align-items: center;

      .img {
        width: 32px;
        height: 32px;
      }

      .orderNo {
        font-weight: bold;
        padding-left: 8px;
      }
    }

    .orderStatus {
      min-width: 0.75rem;
      text-align: right;
      color: #383838;

      &.blue {
        color: #3399ff;
      }

      &.red {
        color: #ff4242;
      }
    }
  }

  .content {
    padding: .16rem .4rem .4rem;

    .content-flex {
      width: 100%;
      display: flex;
      flex-direction: row;
      word-break: break-all;
      margin-top: .24rem;
      line-height: .45rem;
      color: #383838;

      .left {
        color: #787878;
        min-width: 1.62rem;
      }
    }
  }
}
</style>
